import React, { useRef } from "react";
import classNames from "classnames";
import { FormattingRail } from "./FormattingRail";
import { EMAIL_BUILDER_FORMATTING_RAIL_ATTR } from "./formattingRailConstants";
import type { TextVariant } from "../domain/types";
import { useEmailBuilderTouchRailPin } from "./useEmailBuilderTouchRailPin";

type TouchFormattingRailProps = {
  frameRef: React.RefObject<HTMLElement | null>;
  blockId: string;
  typeLabel: string;
  textVariant: TextVariant | "button";
};

export function TouchFormattingRail({
  frameRef,
  blockId,
  typeLabel,
  textVariant,
}: TouchFormattingRailProps) {
  const railRef = useRef<HTMLDivElement>(null);
  const { pinned, pinStyle } = useEmailBuilderTouchRailPin({
    enabled: true,
    frameRef,
    railRef,
    placement: "above",
  });

  return (
    <div
      ref={railRef}
      className={classNames(
        "email-builder-canvas-rail",
        "email-builder-canvas-rail--horizontal",
        "email-builder-canvas-touch-rail",
        "email-builder-canvas-touch-rail--horizontal",
        {
          "email-builder-canvas-touch-rail--pinned": pinned,
        },
      )}
      data-editor-chrome
      data-text-toolbar
      role="toolbar"
      style={
        pinStyle ?? {
          position: "fixed",
          visibility: "hidden",
          pointerEvents: "none",
          top: 0,
          left: 0,
        }
      }
      {...{ [EMAIL_BUILDER_FORMATTING_RAIL_ATTR]: "" }}
      onPointerDown={event => event.stopPropagation()}
      onClick={event => event.stopPropagation()}>
      <div className={"email-builder-canvas-touch-rail__scroll"}>
        <FormattingRail
          blockId={blockId}
          typeLabel={typeLabel}
          textVariant={textVariant}
          layout="inline"
        />
      </div>
    </div>
  );
}
